import { v4 as uuid } from 'uuid';
import Tag from './tag';

export default class VocalsTag extends Tag {
  constructor(name: string, hasVocals: boolean) {
    super(
      {
        name,
        active: true,
        id: uuid(),
      },
      'vocals'
    );
    this.queryValue = hasVocals;
  }
}
